import { render, staticRenderFns } from "./ReviewsChart.vue?vue&type=template&id=9633a58c"
import script from "./ReviewsChart.vue?vue&type=script&lang=js"
export * from "./ReviewsChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports